<template>
    <div class="offset-lg-2 col-lg-8 col-12 my-2">
        <Card>
            <div class="align-start justify-content-between mx-1 column col-12">
                <div class="row justify-content-between">
                    <div class="d-flex">
                        <span class="caption">{{$t('support.tickets.ticket')}}: </span>
                        <p class="font-weight-bold">{{ticket.title}}</p>
                    </div>
                    <base-button @click="close()" type="success" v-if="!['CLOSED', 'RESOLVED'].includes(ticket.status)">
                        <span class="fas fa-check mr-2"></span>
                        {{$t('support.tickets.close')}}
                    </base-button> 
                </div>
                <div class="row">
                    <div class="d-flex">
                        <span class="caption">{{$t('support.tickets.id')}}: </span>
                    </div>
                    <div class="d-flex">
                        <p class="font-weight-bold">{{ticket.identifier}}</p>
                    </div>
                </div>
                <div class="row justify-content-between">
                    <div class="d-flex">
                        <div class="d-flex">
                            <span class="caption">{{$t('support.tickets.created_at')}}: </span>
                        </div>
                        <div class="d-flex">
                            <p class="font-weight-bold">{{$moment(ticket.created_at).format('lll')}}</p>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex">
                            <span class="caption">{{$t('support.tickets.status')}}: </span>
                        </div>
                        <div class="d-flex">
                            <p class="font-weight-bold">{{status.name}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex">
                <ticket-replies
                    ref="replies"
                    v-model="ticket"
                ></ticket-replies>
            </div>
            <div class="d-flex">
                <ticket-reply-form
                    :user="user"
                    :disabled="['RESOLVED'].includes(ticket.status)"
                    v-model="ticket"
                    @push="$refs.replies.scroll()"
                ></ticket-reply-form>
            </div>
        </Card>
    </div>
</template>

<script>
    
    import Card from '../argon/components/Cards/Card'
    import BaseButton from '../argon/components/BaseButton';
    import ticket from './TicketComponents/mixins/ticket'

    import TicketReplyForm from './TicketComponents/Reply/TicketReplyForm'
    import TicketReplies from './TicketComponents/Reply/TicketReplies'

    export default {

        name: 'TicketReply',

        components: {
            Card,
            TicketReplyForm,
            TicketReplies,
            BaseButton,
        },

        mixins: [
            ticket,
        ],

        props: {
            color: {
                type: Object,
                required: true,
            },
            user: Object,
            value: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                ticket: this.value
            }
        },

        methods: {
            close() {
                this.$loading.show()
                return window.axios
                    .put(`/api/app/tickets/close/${this.ticket.id}`)
                    .then(res => {
                        this.ticket.status = res.data.status
                        this.$notify({ type: 'success', message: res.data.message })
                    })
                    .catch(err => {
                        this.$notify({ type: 'danger', message: err.response.data.error })
                    })
                    .finally(() => {
                        this.$loading.close()
                    })
            },
        }
    }
</script>

